import { combineReducers,  } from '@reduxjs/toolkit'
import { connectRouter } from 'connected-react-router';

import {History} from "history";

import AuthReducer from './modules/users/authReducer';
import { ProfileReducer } from './modules/profile/profileReducer';
import {
    WithdrawalReducer
} from './modules/withdrawal/withdrawalReducer';
import {
    DepositReducer
} from './modules/deposit/depositReducer';
import { CurrencyReducer } from './modules/currency/currencyReducer';

const rootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        authReducer: AuthReducer,
        profileReducer: ProfileReducer,
        currencyReducer: CurrencyReducer,
        withdrawalReducer: WithdrawalReducer,
        depositReducer: DepositReducer,
    });

export default rootReducer
